<template>
  <InfoLayout
    v-if="!isMobile"
    :current-path="reverseFull({ name: 'about_us' })"
    :is-policy="false"
  >
    <template #title>
      {{ t('О проекте', options) }}
    </template>
    <template #content>
      <MainContent
        :info-records="context.info_records"
        :info-id="context.info.id"
        :team-members="context.team_members"
        :is-super-user="!!context.request.user?.is_superuser"
        :is-editor-user="hasGroup(context.request, 'editor_group')"
        :site-name="context.request.site.name"
      />
    </template>
  </InfoLayout>
  <div v-else>
    <MainContent
      :info-records="context.info_records"
      :info-id="context.info.id"
      :team-members="context.team_members"
      :is-super-user="!!context.request.user?.is_superuser"
      :is-editor-user="hasGroup(context.request, 'editor_group')"
      :site-name="context.request.site.name"
    />
  </div>
</template>

<script lang="ts" setup>
import hasGroup from 'djanjucks/filters/hasGroup'
import { useContextStore, useURLStore } from 'src/store'
import I18NextVue from 'i18next'
import MainContent from 'src/components/pages/info/about-us/index/components/MainContent/MainContent.vue'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context } = useContextStore()

const isMobile = context.flavour === 'mobile'

const { reverseFull } = useURLStore()
</script>
